module.exports = __webpack_public_path__ + "static/media/consultation_01.2d622ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_01.png
// module id = 574
// module chunks = 0